import { cn } from 'lib/helpers/utility';

import StepperContent from '../StepperContent/StepperContent';
import StepperSidebar from '../StepperSidebar/StepperSidebar';

const StepperLayout = ({
  stepsState,
  phases,
  sidebarType,
  hiddenSubstepCodes,
  restrictedStepsCodes,
  isNarrowScreen,
  sidebarOpen,
  closeSidebar,
  isEnteringFromIntro,
  smartSuggestions,
  isAdmin,
  practice,
  sidebarComponentProps,
  mainContentRef,
  wizardState,
  onExpandStep,
  onCollapseStep,
  onActivateStep,
  onNavigateSubstep,
  headerProps,
  footerProps,
  stepProps
}) => (
  <div
    className={cn(
      'h-screen bg-gradient-to-b from-primary-50 to-primary-200 p-10 [@media(max-width:1200px)]:px-6 [@media(max-width:1200px)]:py-8'
    )}>
    <div
      className={cn('relative flex h-full justify-center gap-10 [@media(max-width:1200px)]:gap-6')}>
      <StepperSidebar
        stepsState={stepsState}
        phases={phases}
        sidebarType={sidebarType}
        hiddenSubstepCodes={hiddenSubstepCodes}
        restrictedStepsCodes={restrictedStepsCodes}
        isNarrowScreen={isNarrowScreen}
        sidebarOpen={sidebarOpen}
        closeSidebar={closeSidebar}
        isEnteringFromIntro={isEnteringFromIntro}
        smartSuggestions={smartSuggestions}
        isAdmin={isAdmin}
        practiceId={practice?.id}
        onExpandStep={onExpandStep}
        onCollapseStep={onCollapseStep}
        onActivateStep={onActivateStep}
        onNavigateSubstep={onNavigateSubstep}
        {...sidebarComponentProps}
      />

      <div
        className={cn(
          'stepper-main-content relative w-full min-w-0 max-w-[1200px] flex-1 justify-center overflow-hidden rounded-xl bg-white',
          isEnteringFromIntro && 'entering'
        )}
        onClick={closeSidebar}>
        <StepperContent
          isAdmin={isAdmin}
          isNarrowScreen={isNarrowScreen}
          isEnteringFromIntro={isEnteringFromIntro}
          mainContentRef={mainContentRef}
          wizardState={wizardState}
          practice={practice}
          headerProps={headerProps}
          footerProps={footerProps}
          stepProps={stepProps}
        />
      </div>
    </div>
  </div>
);

export default StepperLayout;
